export default {
  optOutHint: {
    title: 'Platí pre všetky budúce verzie',
    availability: 'Qmulus už po aktualizáciách neotvorí novinky. Zostávajú vždy dostupné:',
    versionNumber: 'Číslo verzie v používateľskej ponuke',
    showAgain: 'Ak ich chcete po aktualizáciách znova zobrazovať, vyberte {location}.',
  },
};
